import React from 'react';
import { Input, Image, Icon } from 'semantic-ui-react'
import Buttons from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from 'semantic-ui-react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Card from '@material-ui/core/Card';
import HorizontalScroll from 'react-horizontal-scrolling';
import MenuIcon from '@material-ui/icons/Menu';
import ViewAll from './viewall';
import $ from "jquery";
import AppServer from '../../../functions/servername';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Category from './type';
import SparesDetails from './sparedetails';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import ViewGroupParts from './ViewGroupParts';
import Combos from './combos';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
});

class MobileView extends React.Component {

  state = {
    value: 0, search: '', counter: 0, screenStatus: 0, screenName: 'Select Model', viewallArray: [], allParts: [], modelsAndCombos: []
  }

  componentDidMount() {
    this.getModel();
    this.getAllParts();
  }

  getModel() {
    let context = this;
    $.ajax({
      type: 'POST',
      url: AppServer() + 'ui/getmodelsandcombos.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ modelsAndCombos: data })
        } catch (error) {
        }
      },
      error: function(err) {
        alert('Try again!!!!')
      }
    });
  }

  getAllParts() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'id': '', 'name': '', 'type': '' },
      url: AppServer() + 'ui/getallparts.php',
      success: function(data) {
        
        try {
          data = JSON.parse(data);
          context.setState({ allParts: data })
        } catch (error) {
        }
      },
      error: function(err) {
        alert('Try again!!!!')
      }
    });
  }

  changeScreenStatus(screenStatus, screenName, viewallArray, imageLink, type1, type2, previousScreen) {
    this.setState({ screenStatus, screenName, viewallArray, imageLink, type1, type2, previousScreen })
  }


  backButton() {
    let screenStatus1 = this.state.screenStatus1;
    let { screenStatus, screenName, viewallArray, imageLink, type1, type2, previousScreen } = this.state;
    if (screenStatus1 == 1) {
      this.setState({ screenStatus, screenStatus1: 0, screenName, viewallArray, imageLink, type1, type2, previousScreen })
      return;
    }
    if (screenStatus == 'Spares Details') {
      if (previousScreen == 'Section') {
        this.setState({ screenStatus: 'Section', screenName: 'Section', previousScreen: 'Place Order' })
      }
      if (previousScreen == 'Category') {
        this.setState({ screenStatus: 'Category', screenName: 'Category', previousScreen: 'Place Order' })
      }
      if (previousScreen == 'Set') {
        this.setState({ screenStatus: 'Set', screenName: 'Set', previousScreen: 'Place Order' })
      }
    }
    else if (screenStatus == 'Combo') {
      this.setState({ screenStatus: 'Spares Details', screenName: 'Spares Details' })
    }
    else {
      if (previousScreen == 'Select Model') {
        this.setState({ screenStatus: 0, screenName: 'Select Model' })
      }
      if (previousScreen == 'Place Order') {
        this.setState({ screenStatus: 1, screenName: 'Place Order', previousScreen: 'Select Model' })
      }
      if (previousScreen == 'View All') {
        this.setState({ screenStatus: 2, screenName: 'View All', previousScreen: 'Place Order' })
      }
    }
  }

  detailsSparesPage(partno, item) {
    let previousScreen = this.state.previousScreen;
    if (this.state.screenStatus == 'Category' || this.state.screenStatus == 'Set' || this.state.screenStatus == 'Section') {
      this.setState({ screenStatus: 'Spares Details', screenName: 'Spares Details', previousScreen: this.state.screenStatus, sparesDetailsPartno: partno, sparesDetailsItem: item })
    }
    else if (previousScreen == 'Place Order') {
      this.setState({ screenStatus: 'Spares Details', screenName: 'Spares Details', sparesDetailsPartno: partno, sparesDetailsItem: item })
    }
    else {
      this.setState({ screenStatus: 'Spares Details', screenName: 'Spares Details', sparesDetailsPartno: partno, sparesDetailsItem: item })
    }
  }

  screennav(grouptype, groupName, grouporiginaldata) {
    this.setState({ screenStatus1: 1, grouptype, groupName, grouporiginaldata })
  }

  changeState(id, name, screenStatus, screenName) {
    this.setState({ id, name, screenStatus, screenName, previousScreen: 'View All' })
  }

  partcode = event => {
    let value = event.target.value;
    let partno = value.split('->')[0];
    let title = value.split('->')[1];
    let refId = 0;
    let values = 0;
    let dropDown =  event.target.value;
    let allParts = this.state.allParts;
    let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
    if (!customerDualScreenorderList) {
        customerDualScreenorderList = "[]";
    }
    try {
      customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
      if (!customerDualScreenorderList) {
          customerDualScreenorderList = [];
      }
      customerDualScreenorderList.map((v) => {
          if (v.partno == partno && title == v.spare_name) {
              values = 1;
              v.qty = v.qty + 1;
              v.quantity = v.quantity + 1;
          }
          else { 
              refId = v.refId;
          }
      })
    } catch (error) {
      
    }
    refId = refId + 1;
    allParts.map((c) => {
      if (partno == c.partno && title == c.title) {
        if (values == 0) {
            values = values + 1;
            customerDualScreenorderList.push({ 
                'partno': c.partno, 'discountrs': 0,
                'spare_name': c.title, 'partname': c.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                'qty': 1, 'refId': refId, 'brand': 1, 'remarks': 'remarks',
                'tax': c.tax, 'discount': 0, 'quantity': 1, checked: false,
                'billtype': 'Invoice', 'mrp': c.mrp, 'uprice': c.mrp, 
            })
        }
      }
    })
    customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
    this.props.refreshData();
  }

  goToModel(model) {
    this.props.getSparesWithModel(model);
    this.setState({ screenStatus: 1, screenName: 'Place Order', previousScreen: 'Select Model', model })
  }

  viewComboScreen(combo) {
    this.setState({ screenStatus: 'Combo', screenName: 'Combo',  combo })
  }
  
  render() {
    const { fullScreen } = this.props;
    
    let i = 0;
    const displayCounter = this.state.counter > 0;
    let screen = (<div></div>);

    if (this.state.screenStatus == 0) {
      screen = (
        <div class="mobileview">
          <Grid container spacing={2}>
            { this.props.model.map((c) => {
                return (
                  <Grid item xs={4}>
                  <Card onClick={this.goToModel.bind(this, c.name)} id="flex-group-item">
                    <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/model/"+c.id+".jpg"} style={{width: '100%', height: '200px', borderRadius: '5px'}} />
                    <center style={{margin: '5px'}}>
                      <b>
                        {c.name}<br/>
                        {'('+c.tamil_name+')'}
                      </b>
                    </center>
                  </Card>
                  </Grid>
                )
              })
            }
          </Grid>
        </div>
      );
    }
    if (this.state.screenStatus == 1) {
      screen = (
        <div>
          <div class="mobileview">
            { this.props.group.length != 0 ?
              (
                <div>
                    <div style={{display: 'flex', marginTop: '5px'}}>
                      <div id="sub-title">Group</div>
                      <div><Button onClick={this.changeScreenStatus.bind(this, 2, 'Group', this.props.group, 'section', 'Section', 'Section', 'Place Order')} style={{color: 'white', backgroundColor: '#ABB119'}}>View All</Button></div>
                    </div>
                    <HorizontalScroll>
                      {
                        this.props.group.map((c) => {
                          if (i <= 5) {
                            i++;
                            return (
                              <Card onClick={ () => { this.setState({ id: c.id, name: c.name, screenStatus: 'Section', screenName: c.name+' - Section', previousScreen: 'Place Order' }) }} id="flex-group-item">
                                <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/section/"+c.id+".jpg"} style={{width: '200px', height: '200px', borderRadius: '5px'}} />
                                <center style={{margin: '5px'}}>
                                  <b>
                                    {c.name}<br/>
                                    {'('+c.tamil_name+')'}
                                  </b>
                                </center>
                              </Card>
                            )
                          }
                        })
                      }
                    </HorizontalScroll>
                </div>
              ):''
            }
            
            { this.props.cetegory.length != 0 ?
              (
                <div>
                  <div style={{display: 'flex', marginTop: '5px'}}>
                    <div id="sub-title">Category</div>
                    <div><Button onClick={this.changeScreenStatus.bind(this, 2, 'Category', this.props.cetegory, 'category', 'Category', 'Category', 'Place Order')} style={{color: 'white', backgroundColor: '#ABB119'}}>View All</Button></div>
                  </div>
                  <HorizontalScroll>
                    {
                      this.props.cetegory.map((c) => {
                        if (i <= 10) {
                          i++;
                          return (
                            <Card  id="flex-group-item" onClick={ () => { this.setState({ id: c.id, name: c.name, screenStatus: 'Category', screenName: c.name+' - Category', previousScreen: 'Place Order' }) }}>
                              <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/category/"+c.id+".jpg"} style={{width: '200px', height: '200px', borderRadius: '5px'}} />
                              <center style={{margin: '5px'}}>
                                <b>
                                  {c.name}<br/>
                                  {'('+c.tamil_name+')'}
                                </b>
                              </center>
                            </Card>
                          )
                        }
                      })
                    }
                  </HorizontalScroll>
                </div>
              ):''
            }

            { this.props.assembly.length != 0 ?
              (
                <div>
                  <div style={{display: 'flex', marginTop: '5px'}}>
                    <div id="sub-title">Assembly</div>
                    <div><Button onClick={this.changeScreenStatus.bind(this, 2, 'Assembly', this.props.assembly, 'set', 'Set', 'Assembly', 'Place Order')} style={{color: 'white', backgroundColor: '#ABB119'}}>View All</Button></div>
                  </div>
                  <HorizontalScroll>
                    {
                      this.props.assembly.map((c) => {
                        if (i <= 15) {
                          i++;
                          return (
                            <Card onClick={ () => { this.setState({ id: c.id, name: c.name, screenStatus: 'Set', screenName: c.name+' - Assembly', previousScreen: 'Place Order' }) }} id="flex-group-item">
                              <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/set/"+c.id+".jpg"} style={{width: '200px', height: '200px', borderRadius: '5px'}} />
                              <center style={{margin: '5px'}}>
                                <b>
                                  {c.name}<br/>
                                  {'('+c.tamil_name+')'}
                                </b>
                              </center>
                            </Card>
                          )
                        }
                      })
                    }
                  </HorizontalScroll>
                </div>
              ):''
            }
            
            <div>
              <div style={{display: 'flex', marginTop: '5px'}}>
                <div id="sub-title">Model</div>
                <div><Button onClick={this.changeScreenStatus.bind(this, 2, 'Model', this.props.model, 'model', 'Place Order')} style={{color: 'white', backgroundColor: '#ABB119'}}>View All</Button></div>
              </div>
              <HorizontalScroll>
                {
                  this.props.model.map((c) => {
                    if (i <= 25) {
                      i++;
                      return (
                        <Card onClick={this.goToModel.bind(this, c.name)} id="flex-group-item">
                          <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/model/"+c.id+".jpg"} style={{width: '200px', height: '200px', borderRadius: '5px'}} />
                          <center style={{margin: '5px'}}>
                            <b>
                              {c.name}<br/>
                              {'('+c.tamil_name+')'}
                            </b>
                          </center>
                        </Card>
                      )
                    }
                  })
                }
              </HorizontalScroll>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.screenStatus == 2) {
      screen = (<ViewAll type1={this.state.type1} type2={this.state.type2} 
        changeState={this.changeState.bind(this)}
          viewallArray={this.state.viewallArray} imageLink={this.state.imageLink} />)
    }

    if (this.state.screenStatus == 'Category' || this.state.screenStatus == 'Set' || this.state.screenStatus == 'Section') {
      screen =(<Category ref={instance => { this.child1 = instance; }} screennav={this.screennav.bind(this)} model={this.state.model} value={this.state.value} detailsSparesPage={this.detailsSparesPage.bind(this)} refreshData={this.props.refreshData} type={this.state.screenStatus} id={this.state.id} name={this.state.name} />);
    }

    if (this.state.screenStatus == 'Spares Details') {
      screen = (
        <SparesDetails sparesDetailsPartno={this.state.sparesDetailsPartno} 
        detailsSparesPage={this.detailsSparesPage.bind(this)}
        modelsAndCombos={this.state.modelsAndCombos}
        viewComboScreen={this.viewComboScreen.bind(this)}
        sparesDetailsItem={this.state.sparesDetailsItem} refreshData={this.props.refreshData} />
      );
    }

    if (this.state.screenStatus == 'Combo') {
      screen = (<Combos refreshData={this.props.refreshData} detailsSparesPage={this.detailsSparesPage.bind(this)} allParts={this.state.allParts} combo={this.state.combo} combos={this.state.modelsAndCombos.combos} />)
    }

    if (this.state.screenStatus1 == 1) {
      screen = (<ViewGroupParts refreshData={this.props.refreshData} detailsSparesPage={this.detailsSparesPage.bind(this)} originaldata={this.state.grouporiginaldata} name={this.state.groupName} status={this.state.screenStatus1} />);
    }

    let { value } = this.state;
    return (
      <div>
        { this.state.related_spares ?
          (
            <div class='titleRelatedSpares'>Related Spares</div>
          ):''
        }

          <AppBar position="static">
            <Toolbar>
              <IconButton>
                { this.state.screenStatus == 0 ?
                  (
                    <div></div>
                  ):
                  (
                    <Icon onClick={this.backButton.bind(this)} name='arrow left' style={{color: 'white'}} />
                  )
                }
              </IconButton>
              
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <Typography variant="h6" style={{color: 'white'}}>
                    {this.state.screenName}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <datalist id="suggestionspartno">
                      {this.state.allParts.map((c) => {
                        return (
                          <option id='box'>{c.partno+'->'+c.title+'->'+c.local_name}</option>
                        )
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.partcode} autoComplete="on"
                  list="suggestionspartno" value={this.state.dropDown} id={1}/>
                </Grid>
              </Grid>
            </Toolbar>

            
          </AppBar>

        {screen}
        
        <Dialog fullScreen={fullScreen} maxWidth={'md'} onClose={ () => { this.setState({ dialogImageView: false }) }} open={this.state.dialogImageView}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 600}}> {"Spare Image"} </DialogTitle>
          <DialogContent>
            <object data={this.state.dialogImage} type="image/png" style={{height: 400, width: 500}}>
             <img src={require('../../media/icon.png')} style={{height: 400, width: 500}} />
            </object>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialogImageView: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default MobileView;
